import React from 'react';
import MaterialIcon from 'components/common/MaterialIcon';
import CalendarC from 'components/common/Calendar';
import Spin from 'components/common/Spin';
import jMoment from 'components/classes/Jmomen';
import PropTypes from 'prop-types';
import {Card, Button, Row, Col, Form as AntdForm, Input, Select, Modal} from 'antd';
import List from './ListView';
import uuidv1 from 'uuid/v1';
import {show, emptyCalendar, indexDayTypes} from 'routes/Home/Attendance/Calendar/Module';
import {connect} from 'react-redux';


@connect((state) => ({
    calendar: state.Attendance.Calendar.calendar,
    dayTypes: state.Attendance.Calendar.dayTypes,
}), {
    show,
    emptyCalendar,
    indexDayTypes,
})
@autobind
/**
 *
 */
export default class Assignment extends React.PureComponent {
    static propTypes = {
        show: PropTypes.func,
        emptyCalendar: PropTypes.func,
        item: PropTypes.object,
        calendar: PropTypes.object,
        dayTypes: PropTypes.array,
        indexDayTypes: PropTypes.func,

        title: PropTypes.string,
        calendarTitle: PropTypes.string,
        disabledMsg: PropTypes.string,
        titleKey: PropTypes.string,
        idKey: PropTypes.string,
        list: PropTypes.arrayOf(
            PropTypes.object,
        ),
        values: PropTypes.arrayOf(
            PropTypes.object,
        ),
        onSubmit: PropTypes.func,
        onCancel: PropTypes.func,
        disabledItem: PropTypes.func,
        updatePermission: PropTypes.bool,
    };
    static defaultProps = {
        title: 'Pack',
        calendarTitle: 'Calendar Days',
        disabledMsg: 'disabled',
        titleKey: 'title',
        idKey: 'id',
        list: [],
        values: [],
        onSubmit: () => {
        },
        onCancel: () => {
        },
        disabledItem: () => false,
        updatePermission: true,
        item: {
            id: 1,
        },
    };

    /**
     *
     * @param {Object} props
     */
    constructor(props) {
        super(props);

        this.state = {
            calendar: {
                id: 1,
                name: 'calendar',
            },
            item: props.item,
            type: {
                id: 1,
            },
            statuses: [],
            events: [],
            showAddForm: false,
            error: false,
            receiving: true,
            loading: false,
            saving: false,
            showRemoveForm: false,
            dateFoodMeal: {},
            values: props.values,
        };
    }

    componentDidMount() {
        const {indexDayTypes, show} = this.props;
        const {item} = this.state;

        indexDayTypes(null, (err) => {
            if (!err) {
                if (item) {
                    return show(item.id, {includes: ['days']});
                }
                this.setState({
                    receiving: false,
                });
            }
        });
    }

    componentWillReceiveProps(np) {
        if (!app._.isEqual(this.props.calendar, np.calendar)) {
            let statuses = [];
            np.calendar.days.map((day) => {
                let _type = this._getType(day.calendarDayTypeId);

                let _status = {
                    ...day,
                    date: jMoment(day.date).format('jYYYY-jMM-jDD'),
                    title: _type.displayName,
                    color: _type.color,
                };

                if (day.description && day.description !== '') {
                    _status.description = day.description;
                }

                statuses.push(_status);
            });


            this.setState({
                receiving: false,
                calendar: np.calendar,
                statuses,
            });
        }
        if (!app._.isEqual(this.props.values, np.values)) {
            let events = [];
            if (np.values) {
                let _values = this._checkData(np.values);
                _values.map((item) => {
                    if (item.date !== '0000-00-00') {
                        events.push({
                            ...item,
                            date: jMoment(item.date).format('jYYYY-jMM-jDD'),
                            content: `${item.title}`,
                            color: item.color ? `${item.color}` : '#1e98cc',
                        });
                    }
                });
                this.setState({
                    values: np.values,
                    receiving: false,
                    events,
                });
            }
        }
    }

    componentWillUnmount() {
        super.componentWillUnmount();

        this.props.emptyCalendar();
    }

    _getType(id) {
        const {dayTypes} = this.props;

        return dayTypes[dayTypes.findIndex((_dayType) => _dayType.id === id)];
    }

    _checkData(values) {
        const {list, disabledItem, disabledMsg, titleKey, idKey} = this.props;
        let _values = [];

        const __values = typeof values === 'object' ? Object.values(values) : values;


        if (__values) {
            __values.map((item) => {
                if (item && list) {
                    let find = list.find((_item) => _item.id === item[idKey]);
                    if (find && find.id && item.date !== '0000-00-00') {
                        let disabled = disabledItem(item);
                        _values.push({
                            ...item,
                            date: item.date,
                            title: `${find[titleKey]}${disabled ? ` - ${disabledMsg}` : ''}`,
                            color: find.color ? `${find.color}` : '#1e98cc',
                            style: disabled ? {
                                background: '#eee',
                                borderRadius: '3px',
                                opacity: 0.6,
                                cursor: 'not-allowed',
                            } : undefined,
                        });
                    }
                }
            });
        }

        return _values;
    }

    /*  _onAdd() {
        const _selected = this.calendar.selected();

        if (_selected.length > 0) {
          this.setState({
            showAddForm: true,
          });
        }
      }

      _bindMealColor(meal) {
        const {meals} = this.props;
        let _color = '#776655';
        let _meal = meals.find((item) => item.id === meal);

        if (_meal && _meal.color) {
          _color = `${_meal.color}`;
        }

        return _color;
      }

      _bindDateFoodMealName(meal, self, food) {
        const {meals, selfServices, foods} = this.props;
        let _name = '';
        let _meal = meals.find((item) => item.id === meal);
        let _self = selfServices.find((item) => item.id === self);
        let _food = foods.find((item) => item.id === food);

        if (_meal && _meal.title) {
          _name += `${_meal.title} - `;
        } else {
          _name += ` # - `;
        }
        if (_self && _self.title) {
          _name += `${_self.title} - `;
        } else {
          _name += ` # - `;
        }
        if (_food && _food.title) {
          _name += `${_food.title}`;
        } else {
          _name += ` # `;
        }

        return _name;
      }

      _handleAdded() {
        const {statuses, type} = this.state;
        const _selected = this.calendar.selected();
        let _statuses = app._.cloneDeep(statuses);

        this.setState({
          loading: true,
        }, () => {
          _selected.map((_range) => {
            let _date = _range.start;

            for (let _moment = jMoment(_date, 'jYYYY-jMM-jDD'); _date <= _range.end; _moment.add(1, 'day'), _date = _moment.format('jYYYY-jMM-jDD')) {
              let _type = this._getType(type.id);

              let _status = {
                calendarDayTypeId: type.id,
                date: _date,
                title: _type.displayName,
                color: _type.color,
              };

              if (type.description && type.description !== '') {
                _status.description = type.description;
              }

              let _index = _statuses.findIndex((status) => status.date === _date);

              if (_index > -1) {
                _status.id = _statuses[_index].id;
                _statuses[_index] = _status;
              } else {
                _statuses.push(_status);
              }
            }
          });

          this.setState({
            loading: false,
            statuses: _statuses,
            type: {
              id: 1,
            },
            showAddForm: false,
          }, () => this.calendar.reset());
        });


        const {events, dateFoodMeal} = this.state;
        const _selected = this.calendar.selected();
        let _events = app._.cloneDeep(events);
        _selected.map((_range) => {
          let _date = _range.start;

          for (let _moment = jMoment(_date, 'jYYYY-jMM-jDD'); _date <= _range.end; _moment.add(1, 'day'), _date = _moment.format('jYYYY-jMM-jDD')) {
            let _event = {
              foodId: dateFoodMeal.foodId,
              mealId: dateFoodMeal.mealId,
              selfId: dateFoodMeal.selfId,
              date: _date,
              content: this._bindDateFoodMealName(dateFoodMeal.mealId, dateFoodMeal.selfId, dateFoodMeal.foodId),
              color: this._bindMealColor(dateFoodMeal.mealId),
            };

            _events.push(_event);
          }
        });

        _events = app._.uniqWith(_events, (a, b) => a.date === b.date && a.mealId === b.mealId && a.selfId === b.selfId && a.foodId === b.foodId);
        this.setState({
          events: _events,
          showAddForm: false,
          dateFoodMeal: {},
        }, () => this.calendar.reset());
      }

      removeDuplicates(myArr, prop) {
        return myArr.filter((obj, pos, arr) => {
          if (obj[prop]) {
            return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
          } else {
            return true;
          }
        });
      }

      _submit() {
        const {events} = this.state;
        const {store, update, onCancel} = this.props;

        this.setState({
          saving: true,
        }, () => {
          let dateFoodMeals = [];

          events.map((event) => {
            dateFoodMeals.push({
              id: event.id,
              foodId: event.foodId,
              mealId: event.mealId,
              selfId: event.selfId,
              date: jMoment(event.date, 'jYYYY-jMM-jDD').format('YYYY-MM-DD'),
            });
          });

          store(dateFoodMeals, null, (err) => this.setState({saving: false}));
        });
      }

      _dataDateFoodMeals() {
        let _data = [];
        const {events} = this.state;
        let selectedDate = this.calendar && this.calendar.selected();
        if (selectedDate && selectedDate.length === 1 && selectedDate[0].end === selectedDate[0].start) {
          let date = selectedDate[0].start;
          events.map((item) => {
            if (item.date === date) {
              _data.push(Object.assign({}, item, {code: uuidv1()}));
            }
          });
        }
        return _data;
      }

      destroy(DateFoodMeal) {
        const {destroy} = this.props;
        let {events} = this.state;

        let _item = {};
        let _events = [];

        if (DateFoodMeal) {
          events.map((item) => {
            if (!(item.mealId === DateFoodMeal.mealId &&
                item.selfId === DateFoodMeal.selfId &&
                item.foodId === DateFoodMeal.foodId &&
                item.date === DateFoodMeal.date)) {
              _events.push(item);
            } else {
              _item = item;
            }
          });
          if (!app._.isEqual(events, _events)) {
            this.setState({events: _events});
          }
          if (_item && _item.id) {
            destroy(_item.id, {}, () => {
              this.calendar.reset();
            });
          }
        }
      }*/

    _getList(id) {
        const list = this.props.list;

        return list.find((item) => item.id === id);
    }

    /**
     *
     * @private
     */
    _handleAdded() {
        const lists = this.list.selected();
        const events = app._.cloneDeep(this.state.events);
        let values = this.state.values;
        let {titleKey, idKey} = this.props;

        this.calendar.selected() && this.calendar.selected().forEach((_range) => {
            let date = _range.start;

            for (let _moment = jMoment(date, 'jYYYY-jMM-jDD'); date <= _range.end; _moment.add(1, 'day'), date = _moment.format('jYYYY-jMM-jDD')) {
                lists && lists.forEach((id) => {
                    const _list = this._getList(id);
                    if (_list && _list[titleKey]) {
                        let _id = uuidv1();

                        if (events && events.findIndex((item) => item[idKey] === id && item.date === date) === -1) {
                            let _event = {
                                id: _id,
                                date,
                                content: _list[titleKey],
                                color: _list.color ? _list.color : '#456',
                            };
                            _event[idKey] = id;
                            events.push(_event);
                        }
                        if (values && values.findIndex((item) => item[idKey] === id && item.date === date) === -1) {
                            let _value = {
                                id: _id,
                                date: jMoment(date, 'jYYYY-jMM-jDD').format('YYYY-MM-DD'),
                                isParent: false,
                            };
                            _value[idKey] = id;
                            values.push(_value);
                        }
                    }
                });
            }
        });

        this.setState({
            events: app._.uniqWith(events, (a, b) => a.date === b.date && a.id === b.id),
            showAddForm: false,
            showRemoveForm: false,
        }, () => this.calendar.reset());
    }


    /**
     *
     * @private
     */
    _handleRemove() {
        const list = this.list.selected();
        const events = app._.cloneDeep(this.state.events);
        const values = app._.cloneDeep(this.state.values);
        const indexes = [];
        const {disabledItem, idKey} = this.props;
        this.calendar.selected()
            .forEach((_range) => {
                events.forEach((_event, _index) => {
                    let _disabledItem = !disabledItem(_event);
                    if (_range.start <= _event.date && _event.date <= _range.end &&
                        _disabledItem && list.indexOf(_event[idKey]) > -1) {
                        indexes.push(_index);
                        let index = values.findIndex((item) => {
                            return item[idKey] === _event[idKey] &&
                                _disabledItem &&
                                item.date === jMoment(_event.date, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                        });
                        if (index > -1) {
                            values.splice(index, 1);
                        }
                    }
                });
            });

        indexes.sort((a, b) => a - b)
            .reverse()
            .forEach((_index) => events.splice(_index, 1));

        this.setState({
            events,
            values,
            showAddForm: false,
            showRemoveForm: false,
        }, () => this.calendar.reset());
    }

    get _cardExtra() {
        const {loading, saving, values} = this.state;
        const {updatePermission, disabledItem, onSubmit, onCancel, idKey} = this.props;

        return (
            <Button.Group>
                <Button
                    key='cancel'
                    onClick={onCancel}
                >
                    {app.translate('main.Cancel')}
                </Button>
                {updatePermission &&
                <Button
                    type="primary"
                    disabled={loading || saving}
                    loading={saving}
                    onClick={() => {
                        let _values = [];
                        values.map((item) => {
                            let index = _values.findIndex((_i) => item[idKey] === _i.id && item.date === _i.date)
                            if (!disabledItem(item) && index === -1) {
                                _values.push({id: item[idKey], date: item.date});
                            }
                        });

                        _values = app._.orderBy(_values, ['id', 'date'], ['asc', 'asc']);

                        onSubmit(_values);
                    }}
                >
                    {app.translate('main.Submit')}
                </Button>
                }
            </Button.Group>
        );
    }

    _calendar(loading, events, statuses, showAddForm, showRemoveForm) {
        const {updatePermission, calendarTitle} = this.props;
        // console.log(events, statuses);
        return (
            <CalendarC
                title={calendarTitle}
                ref={(input) => this.calendar = input}
                statuses={statuses}
                loading={loading}
                events={events}
                extra={
                    <Button.Group>
                        <Button
                            type="dashed"
                            icon="close"
                            disabled={loading || showAddForm || showRemoveForm}
                            onClick={() => this.calendar.reset()}
                        />
                        {updatePermission &&
                        <Button
                            type="danger"
                            disabled={loading || showAddForm || showRemoveForm}
                            onClick={() => {

                                let selectedDate = this.calendar && this.calendar.selected();
                                if (selectedDate && selectedDate.length > 0) {
                                    this.setState({showRemoveForm: true});
                                } else {
                                    app.message('حداقل یک روز را انتخاب کنید', 'warning');
                                }
                            }}
                        >
                            {app.translate('main.Remove')}
                        </Button>
                        }
                        {updatePermission &&
                        <Button
                            type="primary"
                            disabled={loading || showAddForm || showRemoveForm}
                            onClick={() => {
                                let selectedDate = this.calendar && this.calendar.selected();
                                if (selectedDate && selectedDate.length > 0) {
                                    this.setState({showAddForm: true});
                                } else {
                                    app.message('حداقل یک روز را انتخاب کنید', 'warning');
                                }
                            }}
                        >
                            {app.translate('main.Add')}
                        </Button>
                        }
                    </Button.Group>
                }
            />
        );
    }

    _list(_list, selected = undefined) {
        const {title, titleKey} = this.props;
        return (
            <Row>
                <Col
                    xs={24}
                >
                    <List
                        ref={(input) => this.list = input}
                        items={_list}
                        title={title}
                        primaryText={titleKey}
                        selected={selected ? selected : _list.pluck('id')}
                        icon={(item) => <MaterialIcon name="format-color-fill" style={{color: item.color}}/>}
                    />
                </Col>
            </Row>
        );
    }

    _add(showAddForm, selected = []) {
        const {title, list} = this.props;
        let _title = `${app.translate('main.Assignment')} ${title}`;

        return (
            <Modal
                title={`${app.translate('main.Add')} ${_title}`}
                visible={showAddForm}
                onCancel={() => this.setState({
                    showAddForm: false,
                    type: {
                        id: 1,
                    },
                })}
                footer={[
                    <Button
                        key='cancel'
                        onClick={() => this.setState({
                            showAddForm: false,
                            type: {
                                id: 1,
                            },
                        })}
                    >
                        {app.translate('main.Cancel')}
                    </Button>,
                    <Button
                        type="primary"
                        key='add'
                        disabled={false}
                        onClick={this._handleAdded}
                    >
                        {app.translate('main.Add')}
                    </Button>,
                ]}
            >
                {this._list(list, selected)}
            </Modal>
        );
    }

    _removeList() {
        const events = this.state.events;
        const idKey = this.props.idKey;
        let _list = [];
        let selectedDate = this.calendar && this.calendar.selected();

        if (selectedDate) {
            selectedDate.forEach((_range) => {
                events.forEach((_event) => {
                    if (_range.start <= _event.date && _event.date <= _range.end) {
                        _list.push(this._getList(_event[idKey]));
                    }
                });
            });
        }

        _list = app._.uniqWith(_list, app._.isEqual);
        _list = app._.sortBy(_list, ['id']);

        return _list;
    }

    _remove(showRemoveForm, selected = undefined) {
        const title = this.props.title;
        let _title = `${app.translate('main.Assignment')} ${title}`;
        let _list = this._removeList();

        return (
            <Modal
                title={`${app.translate('main.Remove')} ${_title}`}
                onCancel={() => this.setState({showRemoveForm: false}, () => {
                    this.calendar.reset();
                })}
                visible={showRemoveForm}
                className='Mymodal'
                footer={[
                    <Button
                        key='cancel'
                        onClick={() => this.setState({showRemoveForm: false}, () => {
                            this.calendar.reset();
                        })}
                    >{app.translate('main.Cancel')}</Button>,
                    <Button
                        type="primary"
                        key='add'
                        disabled={_list.length === 0}
                        onClick={this._handleRemove}
                    >
                        {app.translate('main.Delete')}
                    </Button>,
                ]}
            >
                {this._list(_list, selected)}
            </Modal>
        );
    }

    /**
     *
     * @return {XML}
     */
    render() {
        const {loading, showRemoveForm, showAddForm, events, statuses, values} = this.state;
        const title = this.props.title;
        let _title = `${app.translate('main.Assignment')} ${title}`;

        return (
            <Spin
                wrapperClassName="wrapper"
                spinning={loading}
            >
                <Card
                    className="wrapper"
                    title={_title}
                    extra={this._cardExtra}
                >
                    <Row
                        style={{
                            height: '100%',
                            margin: 0,
                        }}
                    >
                        <Col
                            xs={24}
                            style={{
                                height: '100%',
                            }}
                        >
                            {this._calendar(loading, events, statuses, showAddForm, showRemoveForm)}
                        </Col>
                        {this._add(showAddForm, [])}
                        {this._remove(showRemoveForm, undefined)}
                    </Row>
                </Card>
            </Spin>
        );
    }
}
